import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import MessageTemplatesAPI from '../../api/messageTemplates';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getMessageTemplates(_state) {
    return _state.records;
  },
  getMessageTemplateUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getMessageTemplates: async function getMessageTemplates(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, { fetchingList: true });
    try {
      const response = await MessageTemplatesAPI.get({ searchKey });
      commit(types.default.SET_MESSAGE_TEMPLATES, response.data);
    } catch (error) {
      // ignore
    } finally {
      commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createMessageTemplate: async function createMessageTemplate(
    { commit },
    templateObj
  ) {
    commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, { creatingItem: true });
    try {
      const response = await MessageTemplatesAPI.create(templateObj);
      commit(types.default.ADD_MESSAGE_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  updateMessageTemplate: async function updateMessageTemplate(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, { updatingItem: true });
    try {
      const response = await MessageTemplatesAPI.update(id, updateObj);
      commit(types.default.EDIT_MESSAGE_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  deleteMessageTemplate: async function deleteMessageTemplate({ commit }, id) {
    commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, { deletingItem: true });
    try {
      await MessageTemplatesAPI.delete(id);
      commit(types.default.DELETE_MESSAGE_TEMPLATE, id);
      return id;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.default.SET_MESSAGE_TEMPLATE_UI_FLAG, {
        deletingItem: false,
      });
    }
  },
};

const mutations = {
  [types.default.SET_MESSAGE_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.default.SET_MESSAGE_TEMPLATES]: MutationHelpers.set,
  [types.default.ADD_MESSAGE_TEMPLATE]: MutationHelpers.create,
  [types.default.EDIT_MESSAGE_TEMPLATE]: MutationHelpers.update,
  [types.default.DELETE_MESSAGE_TEMPLATE]: MutationHelpers.destroy,
};

export default { state, getters, actions, mutations };
